import { Container, Button } from "react-bootstrap";
import { floating } from "../helpers";
import { useEffect } from "react";
import { CodereHelmet, SPEEDSIZE_PREFIX } from "../../../App";

export default function Freespins({ flag }) {
  useEffect(() => {
    let json = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "¿Cómo funcionan las apuestas gratis en los casinos y casas de apuestas?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Las apuestas gratis ofrecen la oportunidad de ganar dinero sin arriesgar tu propio capital, sin embargo, estas tienen sus condiciones y restricciones para tal fin.",
          },
        },
        {
          "@type": "Question",
          name: "¿Puedo ganar dinero real con apuestas gratis?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Podrás liberar tus ganancias de las apuestas gratis si cumples con las restricciones. Sin embargo, ten en cuenta que las apuestas gratis son aleatorias y suelen generar un monto no retirable para multiplicar lo apostado en el evento deportivo.",
          },
        },
        {
          "@type": "Question",
          name: "¿Cuál es la diferencia entre Free Bets y las apuestas gratis?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No hay diferencia. Tanto las Free Bets como las apuestas gratis son incentivos de casas de apuestas como Codere, permitiéndote apostar sin riesgo, ya que cubren el importe de la apuesta con tu dinero real.",
          },
        },
      ],
    };

    let title = "Free Spins en Juegos de Casino » Duplica tus giros";
    let desc =
      "Conoce las mejores Free Spins en Colombia con Codere. Disfruta de tus juegos de casino con las mejores promociones. ¡Juega ahora y multiplica tu diversión!";
    let can = "https://www.codere.com.co/ayuda/free-spins";

    CodereHelmet(title, desc, can, [json]);
  }, []);

  const top_par = {
    h1: "Disfruta de los Free Spins o Giros gratis y vive la mejor experiencia en el Casino Codere",
    p: "En el Casino Codere cuentas con varios slots con los que podrás sumergirte en una sorprendente aventura girando y ganando. ",
  };

  const p1 = {
    id: "p1",
    h2: "¿Qué son y para qué sirven los giros gratis?",
    p: "En nuestro Casino Codere, los free spins, se otorgan por un número determinado y dependiendo de las promociones que se tengan en la plataforma para una tragamonedas específica. Durante estos giros, la máquina juega por ti y cualquier ganancia que obtengas se añadirá a tu saldo en forma de bono para multiplicarlas.",
    inner: [
      {
        h3: "¿Cómo funcionan?",
        p: "Dependiendo de la promoción y la cantidad, los free spins, estos permitirán partidas o jugadas gratuitas con las que podrás ganar desde recompensas de cash, bonus o multiplicadores de ganancias dentro de la partida.  ",
      },
      {
        h3: "¿Dónde utilizarlos?",
        p: "Los giros gratis podrás utilizarlos en los juegos seleccionados dentro de la promoción. De igual manera, podrás ganarlos durante tu sesión de juego en las tragamonedas destinadas a la pestaña “Casino” tanto en la página web como en la aplicación móvil.  ",
      },
      {
        h3: "Beneficios de los spins gratis",
        p: "Codere tiene para sus usuarios amantes del Casino en Línea, la promoción “Juego de la Semana”. Aquí podrás aceptar 5 giros gratis todos los días durante el periodo promocional. Solo debes ingresar al botón “Casino” y al juego seleccionado para aceptarlos para que puedas divertirte y ganar.  Además de la diversión y la oportunidad de ganar, los giros gratis te permiten probar nuevos juegos sin riesgo, ampliando así tu experiencia en el casino.",
      },
    ],
  };

  const p2 = {
    id: "p2",
    h2: "¿Cómo conseguir los Free Spins con Codere?",
    p: "Los giros gratis, como se menciona, son gratis y cada usuario los podrá recibir tanto en la promoción “Juego de la Semana” o en cada tragamonedas con la función “jugadas gratis”. ",
  };

  const p3 = {
    id: "p3",
    h2: "Consejos para aprovechar al máximo los Free Spins ",
    p: "Para aprovechar los giros gratis, se deben tener en cuenta ciertos parámetros para vivir una gran experiencia:",
    ul: [
      "Comprender el juego: cuando ingresas al slot o tragamonedas, recuerda que hay una serie de instrucciones donde se pueden entender los tipos de bonus, combinaciones y scatters que te pueden brindar ganancias o líneas exitosas.",
      "Identificar los requisitos: Recuerda que los giros gratis, no garantizan ganancias, a menos de que se cumplan con los requisitos para liberar los bonos.",
      "Sér responsable: Juega con responsabilidad y lee los términos y condiciones para destinar los conocimientos para vivir una gran experiencia con los giros gratis.",
    ],
  };

  const preguntas = {
    id: "preguntas",
    h2: "Preguntas Frecuentes",
    inner: [
      {
        h3: "¿Cómo puedo conseguir free spins sin depósito?",
        p: "A través de nuestra promoción “Juego de la Semana” los usuarios podrán disfrutar cada día de sus giros. Para activarlos después del correcto registro, solo deben ingresar al juego seleccionado y aceptarlos antes de jugar y cada giro tiene un valor de $1000 COP.",
      },
      {
        h3: "¿Puedo ganar dinero real con los free spins?",
        p: "Sí, las ganancias de los giros gratis pueden ser dinero real, pero debes cumplir con el requisito de apuesta de 50 veces el monto de la bonificación antes de poder retirarlas.",
      },
    ],
  };

  return (
    <div className="codere-green">
      {floating("Multiplica tus posibilidades")}
      <div
        className="top-bg-seo "
        style={{
          backgroundImage: `url(${SPEEDSIZE_PREFIX}https://www.codere.com.co/colombia/images/seo-ayuda/free-spins-${
            flag ? "mobile" : "desktop"
          }.jpg)`,
          backgroundSize: "cover",
        }}
      ></div>

      <Container>
        <div>
          <h1 className="header mt-4 mb-3">{top_par.h1}</h1>

          <p>{top_par.p}</p>
        </div>

        <div id={p1.id}>
          <h2>{p1.h2}</h2>
          <p>{p1.p}</p>
          <div className="px-3">
            {p1.inner.map((inn, i) => (
              <div key={i}>
                <h3>{inn.h3}</h3>
                <p>{inn.p}</p>
              </div>
            ))}
          </div>
        </div>

        <div id={p2.id}>
          <h2 className="mt-4 mb-3">{p2.h2}</h2>
          <p>{p2.p}</p>
        </div>

        <div id={p3.id}>
          <h2 className="mt-4 mb-3">{p3.h2}</h2>
          <p>{p3.p}</p>
          <ul>
            {p3.ul.map((li, i) => {
              let [underline, p] = li.split(":");
              return (
                <li key={i}>
                  <u>{underline}</u>: {p}
                </li>
              );
            })}
          </ul>
        </div>

        <div id={preguntas.id}>
          <h2>{preguntas.h2}</h2>
          <div className="px-3">
            {preguntas.inner.map((inn, i) => (
              <div key={i}>
                <h3>{inn.h3}</h3>
                <p>{inn.p}</p>
              </div>
            ))}
          </div>

          <Button
            href={"https://m.codere.com.co/deportesCol/#/mso/RegistroCONewPage"}
            className="cas-reg-btn"
            rel="nofollow"
          >
            Registrate
          </Button>
        </div>
      </Container>
    </div>
  );
}
